"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normBlockList = normBlockList;
exports.normExerciseBlockList = normExerciseBlockList;
exports.normExerciseList = normExerciseList;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function normBlockList(data) {
  return data.blockList.reduce(function (result, item) {
    return _objectSpread({}, result, _defineProperty({}, item.id, item));
  }, {});
}

function normExerciseBlockList(exerciseList) {
  return Object.values(exerciseList).reduce(function (result, exercise) {
    var blocks = Object.values(exercise.blockList).reduce(function (sum, block) {
      return _objectSpread({}, sum, _defineProperty({}, block.id, block));
    }, {});
    return _objectSpread({}, result, blocks);
  }, {});
}

function normExerciseList(exerciseList) {
  return Object.values(exerciseList).reduce(function (result, item) {
    var idList = Object.values(item.blockList).map(function (block) {
      return block.id;
    });
    return _objectSpread({}, result, _defineProperty({}, item.exerciseId, _objectSpread({}, item, {
      blockList: idList
    })));
  }, {});
}